import { ButtonProps } from '@mui/material';
import { Close } from '@portals/icons';
import clsx from 'clsx';
import i18next from 'i18next';
import React from 'react';

import { IconButton } from '../IconButton/IconButton';

export type CloseButtonProps = Pick<ButtonProps, 'onClick'>;

// eslint-disable-next-line import/no-named-as-default-member
const t = i18next.getFixedT.bind(i18next)(null, 'core', 'aria.label');

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      circular={true}
      onClick={onClick}
      aria-label={t('closeButton')}
      className={clsx('PortalsCloseButton-Button')}
    >
      <Close fontSize="inherit" />
    </IconButton>
  );
};
